const ROLE ={
    '1' : 'SUPER_ADMIN',
    '2' : 'ADMIN',
    '3' : 'CLIENT',
    '4' : 'DELEGATE'
}

module.exports = ROLE;